<template>
    <!-- 抗癌公开课 -->
    <div class="curriculum-list">
        <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="已经到底" @load="onLoad">
                <Anticancer v-for="item in channelList" :key="item.id" :dataItem="item" :isContent="false" />
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import { Anticancer } from '@/components/contentSelection'

export default {
    components: {
        Anticancer
    },
    data() {
        return {
            loading: true,
            finished: false,
            isLoading: true,
            channelList: [],
            page: {
                page: 1,
                pageSize: 5
            },
            total: 0,
            record_id: 0
        }
    },
    methods: {
        onLoad() {
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetch('channelList')
        },
        onRefresh() {
            this.isLoading = true
            this.page = { page: 1, pageSize: 5 }
            this.fetch('channelList')
        },
        fetch(scene) {
            if (scene === 'channelList') {
                Interface.getData('get', Interface.anticancer.curriculumList, this.page).then(res => {
                    if (!this.loading) {
                        this.channelList = res.data.list
                    } else {
                        this.channelList = [...this.channelList, ...res.data.list]
                    }
                    this.total = res.data.total
                    this.loading = false
                    this.isLoading = false
                    if (this.channelList.length >= this.total) {
                        this.finished = true
                    }
                })
            }
        },
        onScroll() {
          let list = document.querySelector('.van-list')
          let tempArr = []
          for (let i = 0; i < list.children.length; i++){
            if (Math.abs(list.children[i].getBoundingClientRect().top) < 5) {
              let item = this.channelList[i]
              let obj = { type: 14, origin_id: item.id, title: item.title,
                page_type: 3 }
                tempArr.push(obj)
              Interface.exposureFootPrint(JSON.stringify(tempArr))
            }
          }

        }
    },
    created() {
        Interface.getShareInfo(this,"博医同行-抗癌公开课","","", 101, '', Interface.host + '/#/curriculum?source_type=1')
        this.fetch('channelList')
        Interface.getData('post',Interface.footprint, {
          id: 1,
          type: 101,
          content_type: 0,
          page_type: 3,
          source_type: 0,
          parent_id: 0,
          record_id: 0,
          title: '抗癌公开课列表页'
        }).then( (res) => {
          if (res.code == 0) {
            this.record_id = res.data.record_id
          }
        })
        Interface.CoFootPrint(14)

    },
    beforeRouteLeave(to, from, next) {
      if (this.record_id) {
        Interface.mFootPrint(1, 101,0, 3, 0, 0,this.record_id,'抗癌公开课列表页')
      }
      next()
    }
}
</script>

<style lang="scss">
.curriculum-list {
    background: #f2f2f2;
    height: 98vh;
    padding-top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/anticancer/curriculum/list/index.vue